import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import { getConfig } from 'utils/config'
import styles from './IframeViewer.scss'
import Alert from 'components/Alert'

export class IframeViewer extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
  }
  static defaultProps = {
    title: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }

  hideLoading = () => {
    this.setState({
      loading: false,
    })
  };

  render() {
    const {
      title, url,
    } = this.props

    return (
      <div className={styles.baseFrame}>
        <div id="reportAlert" style={{ marginBottom: '15px' }}>
          <Alert showCloseButton={false} type="info">
            Please ensure you are connected to VPN to view reports
          </Alert>
        </div>
        {this.state.loading ? (
          <Loading pageLoading />
        ) : null}

        <iframe
          frameBorder="0"
          id="ssrsIframe"
          onLoad={this.hideLoading}
          scrolling="no"
          src={`${getConfig().REPORT_SERVER_URL}${url}`}
          title={`${title}`}
        />
      </div>
    )
  }
}

export default IframeViewer



// WEBPACK FOOTER //
// ./src/components/IframeViewer/IframeViewer.js